import { useState } from "react";

/**
 * The catalog logo beside a symbol. A broken or missing URL falls back to a
 * lettered disc rather than a broken-image glyph, and the symbol text beside
 * it is always rendered, so the logo carries no information on its own.
 */
export function TokenLogo({ url, symbol }: { url: string | null; symbol: string }) {
  const [failed, setFailed] = useState(false);
  if (!url || failed) {
    return (
      <span className="token-logo token-logo-fallback" aria-hidden="true">
        {symbol.slice(0, 1)}
      </span>
    );
  }
  return (
    <img
      className="token-logo"
      src={url}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
